// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PersonalizingHome_wrapper__Rq_qr","title":"PersonalizingHome_title__dJQlh"};